













































helpers = require('../../helpers.coffee')
on_clickaway = require('vue-clickaway')

view_model =
  mixins: [ on_clickaway.mixin, require('../../mixins/users_options.coffee') ]

  components:
    tagsAutocomplete: require('../shared/autocomplete/tags')

  props:
    filters:
      default: -> {}

    unselected_ids:
      default: -> []

    selected_ids:
      default: -> []

    count_all_contacts:
      default: -> 0

    count_page_contacts:
      default: -> 0

  data: ->
    tag_created: null
    selected_page: false
    selected_all: false
    show_change_tags: false
    users_options: []
    current_user: Session.current_user
    current_company: Session.current_company

  computed:
    disabled_buttons: ->
      @count_selected_contacts == 0

    some_selected: ->
      @selected_ids.length > 0 || @unselected_ids.length > 0

    all_selected: ->
      @count_selected_contacts == @count_all_contacts && @unselected_ids.length == 0

    select_button_class: ->
      clazz = ''
      if @all_selected && @count_all_contacts > 0
        clazz = "all_selected"
      else if @some_selected
        clazz = "some_selected"
      clazz

    count_selected_contacts: ->
      if @selected_all
        count = @count_all_contacts - @unselected_ids.length
      else
        count = @selected_ids.length

      @clearSelected() if count == 0 && (@selected_all || @selected_page)
      count

    toogle_tag_display_menu: ->
      if @show_change_tags
        { display: 'block' }
      else
        { display: 'none' }

  methods:
    showUserOption: (user) ->
      @current_company.account_setting.seller_can_change_responsability || !(user.id == @current_user.id && user.isSeller())

    selection: ->
      if @all_selected || @some_selected
        @clearSelected()
      else
        @setSelectPage()

    toogleShowChangeTags: (tag) ->
      @tag_created = if tag.id then tag else null
      @show_change_tags = !@show_change_tags

    closeShowChangeTags: ->
      @show_change_tags = false

    clearSelected: (data={})->
      @selected_all     = false
      @selected_page    = false
      @show_change_tags = false
      EventsBus.$emit 'ContactList:SelectedAll', { @selected_all }

    setSelectPage: ->
      @selected_page = true
      EventsBus.$emit 'ContactList:SelectedPage', { @selected_page }

    remSelectPage: ->
      @selected_page = false
      EventsBus.$emit 'ContactList:SelectedPage', { @selected_page }

    toggleSelectAll: ->
      @selected_all = !@selected_all
      EventsBus.$emit 'ContactList:SelectedAll', { @selected_all }

    openDestroyContactsConfirmationModal: ->
      EventsBus.$emit 'confirm-modal-show', id: 'confirm-remove-contacts' unless @disabled_buttons

    userSelected: (user) ->
      event.originalEventName = 'user-selected'
      @$emit 'user-selected', { event, user }

    loadUsersOptionsSuccess: (data) ->
      @users_options = data.users

  created: ->
    EventsBus.$on 'ContactList:ClearSelections', @clearSelected
    EventsBus.$on 'MassActions:Autocomplete:TagCreated', @toogleShowChangeTags

  beforeDestroy: ->
    EventsBus.$off 'ContactList:ClearSelections', @clearSelected
    EventsBus.$off 'MassActions:Autocomplete:TagCreated', @toogleShowChangeTags

exports.default = helpers.vue_include(view_model)



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/contacts/mass_actions.vue